import { Controller } from "stimulus"
import axios from 'axios'

import { validateSIRENOrSIRET, validateBCE, validateIDE } from '../../lib/business_ids'

export default class extends Controller {

  static targets = [
    "form", "country", "request", "cible", "region", "longueur", "results", "searchButton"
  ]

  connect() {
  }

  validate_entreprise_id() {
    this.requestTarget.value = this.requestTarget.value.replace(/[^0-9]/g, '')
    let valid = false
    switch (this.countryTarget.value) {
      case "FR":
        valid = validateSIRENOrSIRET(this.requestTarget.value)
        break
      case "BE":
        valid = validateBCE(this.requestTarget.value)
        break
      case "CH":
        valid = validateIDE(this.requestTarget.value)
        break
    }
    this.searchButtonTarget.disabled = !valid
  }

  cible_changed() {
    if (this.cibleTarget.value == "nom_entreprise") {
      this.regionTarget.disabled = false
      this.longueurTarget.disabled = false
    } else {
      this.regionTarget.disabled = true
      this.longueurTarget.disabled = true
    }
    this.regionTarget.value = ""
    this.requestTarget.value = ""
  }

  country_changed() {
    if (this.countryTarget.value == "FR") {
      this.cibleTarget.querySelector('option[value="nom_entreprise"]').disabled = false
      this.cibleTarget.value = "nom_entreprise"
      this.regionTarget.disabled = false
      this.longueurTarget.disabled = false
    } else {
      this.cibleTarget.querySelector('option[value="nom_entreprise"]').disabled = true
      this.cibleTarget.value = "siret"
      this.regionTarget.disabled = true
      this.longueurTarget.disabled = true
    }
    this.requestTarget.value = ""
  }

  request_changed() {
    console.log(this.countryTarget.value, this.cibleTarget.value)
    if (this.cibleTarget.value == "nom_entreprise") {
      if (this.countryTarget.value == "FR" && this.requestTarget.value.length > 2) {
        this.searchButtonTarget.disabled = false
      }
    } else {
      this.validate_entreprise_id()
    }
  }

  async search_clicked(e) {
    e.preventDefault()
    const formData = new FormData(this.formTarget);
    const qs_params = new URLSearchParams(formData).toString();
    const url = `${this.element.dataset.path}/?${qs_params}`
    this.searchButtonTarget.disabled = true
    try {
      const response = await axios.get(url)
      this.resultsTarget.innerHTML = response.data
    } catch (error) {
      console.error("Erreur lors de la requête :", error);
    }
    finally {
      this.searchButtonTarget.disabled = false
    }
  }

}